import { ArrowUpRight, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { organization, programs } from '../data/siteData';
import { assetPath } from '../utils/assetPath';

const homeSection = (section) => `${import.meta.env.BASE_URL}#${section}`;

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__shape" aria-hidden="true" />
      <div className="shell footer__grid">
        <div className="footer__brand">
          <img src={assetPath('/assets/brand/logo-fundacion-square.png')} alt="Fundación Tony" />
          <p>Transformamos vidas para construir un mejor futuro.</p>
          <div className="footer__socials">
            <a href={organization.facebook} target="_blank" rel="noreferrer" aria-label="Facebook de Fundación Tony"><img src={assetPath('/assets/icons/facebook.svg')} alt="" /></a>
            <a href={organization.instagram} target="_blank" rel="noreferrer" aria-label="Instagram de Fundación Tony"><img src={assetPath('/assets/icons/instagram.svg')} alt="" /></a>
          </div>
        </div>
        <div>
          <h2>Explora</h2>
          <Link to="/">Inicio</Link>
          <a href={homeSection('nosotros')}>Nosotros</a>
          <a href={homeSection('actualidad')}>Galería</a>
          <Link to="/contacto">Contacto</Link>
        </div>
        <div>
          <h2>Programas</h2>
          {programs.map((program) => <Link key={program.id} to={program.path}>{program.shortTitle}</Link>)}
          <a href={organization.scholarships} target="_blank" rel="noreferrer">Convocatoria de becas <ArrowUpRight size={14} /></a>
        </div>
        <div>
          <h2>Hablemos</h2>
          <a href="tel:+522299842590"><Phone size={16} /> {organization.phone}</a>
          <Link to="/contacto"><Mail size={16} /> Enviar una consulta</Link>
          <p className="footer__note">Veracruz — Boca del Río, México</p>
        </div>
      </div>
      <div className="shell footer__bottom">
        <span>© {new Date().getFullYear()} Fundación Tony</span>
        <span>Compromiso social de Grupo Tony</span>
      </div>
    </footer>
  );
}
